import React from 'react';
import { Route } from 'react-router-dom';
import Registration from './auth/Registration';

export default [
    <Route exact path="/register" component={Registration} noLayout />,
];
